import {toggleArrayValue} from "../FeatureCreator/FeaturesFilters/filtersFunctions";
import {ActionTypes} from "./AccountActions";
import {ACCOUNT_SECTIONS} from "./Sections/sectionNames";
import {CUSTOMERS_INFO_CLEAR} from "../../constants/actionTypes";

const initialState = {
  sectionsOpened: [ACCOUNT_SECTIONS.company_information],
  accountPageInfoIsSet: false,
  accountPageInfo: {
    entityId: null,
    clientType: null,
    clientSubType: null,
    isEmployee: false,
    isCustomer: false,
    isFabricator: false,
    isStore: false,
    isMasterFabricator: false,
    isNew: false,
    canAddFabricator: false,
    canChangePassword: false,
    canEditCompanyName: false,
    canEditFields: false,
    canEditName: false,
    canEditPhone2: false,
    canEditPrimaryEmail: false,
    urlOnSave: ""
  },
  billingInformation: {
    ccName: "",
    ccNum: "",
    ccType: "",
    ccExpMonth: "",
    ccExpYear: "",
    ccCVV: "",
    ccTermsApproved: "",
    saveCC: false,
    onCCSave: null // callback after cc popup is saved
  },
  paymentGatewayInfo: {
    showPaymentGatewaysPopup: false,
    paymentGatewayManaging: null,
    paymentGateway_MxMerchant_MerchantId: '',
    paymentGateway_MxMerchant_ApiKey: '',
    paymentGateway_MxMerchant_ApiSecret: '',
    paymentGateway_MxMerchant_NachaId: '',
    paymentGateway_MxMerchant_TestMode: false,
    paymentGateway_AuthNet_ApiLogin: '',
    paymentGateway_AuthNet_NachaId: '',
    paymentGateway_AuthNet_CustomEndpointUrl: '',
    paymentGateway_AuthNet_TestMode: false,
    paymentGateway_AuthNet_TransactionKey: '',
    paymentGateway_Cliq_FabricatorSubMid: '',
    paymentGateway_Cliq_DistributorSubMid: '',
    paymentGateway_Cliq_GatewayId: '',
    paymentGateway_Cliq_ServiceKey: ''
  },
  cliqSubMidInfo: {
    showCliqSubMidPopup: false,
    cliqSubMid_CompanyName: '',
    cliqSubMid_ContactName: '',
    cliqSubMid_CorporateState: '',
    cliqSubMid_CorporateType: '',
    cliqSubMid_AverageTicket: '',
    cliqSubMid_FundingFrequency: '',
    cliqSubMid_IncorporateDate: '',
    cliqSubMid_Industry: '',
    cliqSubMid_MonthlyVolume: '',
    cliqSubMid_PhoneNumber: '',
    cliqSubMid_TaxId: '',
    cliqSubMid_AccountNumber: '',
    cliqSubMid_RoutingNumber: '',
    cliqSubMid_Address_Address1: '',
    cliqSubMid_Address_Address2: '',
    cliqSubMid_Address_CityTown: '',
    cliqSubMid_Address_CountryCode: '',
    cliqSubMid_Address_PostalCode: '',
    cliqSubMid_Address_StateProvince: '',
    cliqSubMid_Owners_DOB: '',
    cliqSubMid_Owners_Email: '',
    cliqSubMid_Owners_FirstName: '',
    cliqSubMid_Owners_FullName: '',
    cliqSubMid_Owners_LastName: '',
    cliqSubMid_Owners_MiddleName: '',
    cliqSubMid_Owners_PhoneNumber: '',
    cliqSubMid_Owners_DriverLicenseNumber: '',
    cliqSubMid_Owners_DriverLicenseState: '',
    cliqSubMid_Owners_SSN: '',
    cliqSubMid_Owners_OwnershipPercentage: '',
    cliqSubMid_Owners_Address_Address1: '',
    cliqSubMid_Owners_Address_Address2: '',
    cliqSubMid_Owners_Address_CityTown: '',
    cliqSubMid_Owners_Address_CountryCode: '',
    cliqSubMid_Owners_Address_PostalCode: '',
    cliqSubMid_Owners_Address_StateProvince: ''
  },
  subscriptionsInfo: {
    programTypeKey: "",
    bathroomProgramType: "Select",
    bathroomPaymentType: "Select Program",
    kitchenPaymentType: "Select Program",
    kitchenProgramType: "Select",
    initialBathroomPaymentType: "Select Program",
    initialBathroomProgramType: "Select",
    initialKitchenPaymentType: "Select Program",
    initialKitchenProgramType: "Select",
    fireplaceProgramType: "Select",
    fireplacePaymentType: "Select Program",
    laundryroomPaymentType: "Select Program",
    laundryroomProgramType: "Select",
    leadformPaymentType: "Select Program",
    leadformProgramType: "Select",
    initialFireplacePaymentType: "Select Program",
    initialFireplaceProgramType: "Select",
    initialLaundryRoomPaymentType: "Select Program",
    initialLaundryRoomProgramType: "Select",
    initialLeadformPaymentType: "Select Program",
    initialLeadformProgramType: "Select",
    showingESignFor: null,
    fabricatorNeedToSignAgreement: false
  },
  activeWebHookDataType: "Json",
  formSubmitted: false
};

export default function accountReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.TOGGLE_SECTION_OPENED:
      return {...state, sectionsOpened: toggleArrayValue([...state.sectionsOpened], action.payload.sectionKey)};
    case ActionTypes.TOGGLE_ALL_SECTIONS_OPENED:
      return {...state, sectionsOpened: action.payload.openAll ? Object.keys(ACCOUNT_SECTIONS) : []};
    case ActionTypes.SET_ACCOUNT_PAGE_INFO:
      return Object.assign({}, state, {
        ...action.payload,
        accountPageInfoIsSet: true
      });
    case ActionTypes.SET_BILLING_INFORMATION:
      return {
        ...state,
        billingInformation: Object.assign({}, state.billingInformation, action.payload.billingInformation)
      };
    case ActionTypes.SET_PAYMENT_GATEWAY_INFO:
      return {
        ...state,
        paymentGatewayInfo: Object.assign({}, state.paymentGatewayInfo, action.payload.paymentGatewayInfo)
      };
    case ActionTypes.SET_MANUFACTURER_FILTERS:
      return {
        ...state,
        manufacturerFilters: Object.assign({}, state.manufacturerFilters, action.payload.manufacturerFilters)
      };
    case ActionTypes.SET_CLIQ_SUBMID_INFO:
      return {
        ...state,
        cliqSubMidInfo: Object.assign({}, state.cliqSubMidInfo, action.payload.cliqSubMidInfo)
      };
    case ActionTypes.SET_SUBSCRIPTIONS_INFO:
      console.log('setting subscription info', state.subscriptionsInfo, action.payload, Object.assign({}, state.subscriptionsInfo, action.payload.subscriptionsInfo));
      return {
        ...state,
        subscriptionsInfo: Object.assign({}, state.subscriptionsInfo, action.payload.subscriptionsInfo)
      };
    case ActionTypes.SET_ACTIVE_WEB_HOOK_DATA_TYPE:
    case ActionTypes.FORM_SUBMIT:
      return Object.assign({}, state, {
        ...action.payload
      });
    case CUSTOMERS_INFO_CLEAR:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
}
